module.exports = __webpack_public_path__ + "img/product.bfe35e2d.png";